import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Company } from "src/modules/database/shared/company.model";
import { FrontendField } from "../../netgen/FrontendField";
import { FrontendFieldType } from "../../netgen/FrontendFieldType";
import { FrontendForm } from "../../netgen/FrontendForm";
import { AdminBaseEditComponent } from "../admin-base-edit/admin-base-edit.component";
import { EditGeneralCompaniesComponent } from "../edit-general-companies/edit-general-companies.component";

@Component({
    selector: "app-edit-general-company",
    templateUrl: "../../../sm-base/components/admin-base-edit/admin-base-edit.component.html",
    styleUrl: "../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditGeneralCompanyComponent extends AdminBaseEditComponent<Company> {

    definition = EditGeneralCompaniesComponent.staticDefinition;

    getForm(): FrontendForm {
        return new FrontendForm([
            new FrontendField("name", this.app.t("entity.Company.fields.nameEdit"), FrontendFieldType.string, { mandatory: true }),
            new FrontendField("sortName", this.app.t("entity.Company.fields.sortName"), FrontendFieldType.string),
            new FrontendField("useUserGroupLevel", this.app.t("entity.Company.fields.useUserGroupLevel"), FrontendFieldType.bool)
        ]);
    }
}
